import { OptionList } from '../options';
import { createContext, FC, ReactNode } from 'react';

interface OptionContextProps {
  options: OptionList;
}

export const OptionContext = createContext({} as OptionContextProps);

interface OptionContextProviderProps {
  children: ReactNode;
  options: OptionList;
}

export const OptionContextProvider: FC<OptionContextProviderProps> = ({
  children,
  options,
}) => {
  return (
    <OptionContext.Provider
      value={{
        options: options,
      }}
    >
      {children}
    </OptionContext.Provider>
  );
};

export default OptionContext;
